import React from 'react';
import { X, ExternalLink } from 'lucide-react';

const ProfileCard = ({ profile, onClose, selectedHashtag = null }) => {
  const getProfileLink = () => {
    switch (profile.platform) {
      case 'twitter':
        return `https://twitter.com/${profile.username}`;
      case 'facebook':
        return `https://facebook.com/${profile.id}`;
      case 'instagram':
        return `https://instagram.com/${profile.username}`;
      case 'tiktok':
        return `https://tiktok.com/@${profile.username}`;
      default:
        return '#';
    }
  };

  const getPostLink = (post) => {
    switch (profile.platform) {
      case 'twitter':
        return `${getProfileLink()}/status/${post.id}`;
      case 'facebook':
        return `https://facebook.com/${post.id}`;
      case 'instagram':
        return `https://instagram.com/p/${post.id}`;
      case 'tiktok':
        return `https://tiktok.com/@${profile.username}/video/${post.id}`;
      default:
        return '#';
    }
  };

  const renderPlatformSpecificInfo = () => {
    switch (profile.platform) {
      case 'twitter':
        return (
          <>
            
             <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Full Name</span>
              <span style={styles.infoValue}>{profile.full_name}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Account Verified</span>
              <span style={styles.infoValue}>{profile.verified}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Description</span>
              <span style={styles.infoValue}>{profile.description}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Location</span>
              <span style={styles.infoValue}>{profile.location}</span>
            </div>
            
          </>
        );
      case 'tiktok':
        return (
          <>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Signature</span>
            <span style={styles.infoValue}>{profile.signature}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Description</span>
            <span style={styles.infoValue}>{profile.description}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Full Name</span>
            <span style={styles.infoValue}>{profile.full_name}</span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Location</span>
            <span style={styles.infoValue}>{profile.location}</span>
          </div>
          </>
          
          
        );
      case 'instagram':
        return (
          <>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Age Group</span>
              <span style={styles.infoValue}>{profile.age_group}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Age Approximation</span>
              <span style={styles.infoValue}>{profile.age_approx}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Business Category</span>
              <span style={styles.infoValue}>{profile.business_category}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Languages</span>
              <span style={styles.infoValue}>{profile.langs?.join(', ')}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Email</span>
              <span style={styles.infoValue}>{profile.public_email}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Phone</span>
              <span style={styles.infoValue}>
                {profile.public_phone_country_code} {profile.public_phone_number}
              </span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Gender</span>
              <span style={styles.infoValue}>{profile.gender}</span>
            </div>
          </>
        );
      case 'facebook':
        return (
          <>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Current City</span>
              <span style={styles.infoValue}>{profile.current_city}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Education</span>
              <span style={styles.infoValue}>{profile.education}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Email</span>
              <span style={styles.infoValue}>{profile.email}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Phone</span>
              <span style={styles.infoValue}>{profile.phone}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Hometown</span>
              <span style={styles.infoValue}>{profile.hometown}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Workplace</span>
              <span style={styles.infoValue}>{profile.workplace}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Location</span>
              <span style={styles.infoValue}>
                {profile.latitude}, {profile.longitude}
              </span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Age Group</span>
              <span style={styles.infoValue}>{profile.age_group}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Age Approximation</span>
              <span style={styles.infoValue}>{profile.age_approx}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Gender</span>
              <span style={styles.infoValue}>{profile.gender}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Address</span>
              <span style={styles.infoValue}>{profile.address}</span>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const getProfileImage = () => {
    switch (profile.platform) {
      case 'twitter':
        return profile.profile_image_url;
      case 'tiktok':
        return profile.profile_avatar_url;
      case 'instagram':
      case 'facebook':
        return profile.profile_photo_url;
      default:
        return '';
    }
  };

  const renderHashtagPosts = () => {
    if (!selectedHashtag || !profile.posts) return null;

    const hashtagPosts = profile.posts.filter(post => {
      const hashtagPattern = new RegExp(`#${selectedHashtag}\\b|#${selectedHashtag}$|\\b${selectedHashtag}\\b`, 'i');
      return hashtagPattern.test(post.text) || 
             (post.hashtags && post.hashtags.includes(selectedHashtag)) ||
             (post.text_tags && post.text_tags.includes(selectedHashtag));
    });

    if (hashtagPosts.length === 0) return null;

    return (
      <div style={styles.hashtagPosts}>
        <h4 style={styles.hashtagPostsTitle}>Posts with #{selectedHashtag}</h4>
        <div style={styles.postList}>
          {hashtagPosts.map((post, index) => (
            <div key={index} style={styles.postItem}>
              <p style={styles.postText}>{post.text}</p>
              <a
                href={getPostLink(post)}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.postLink}
              >
                View Post <ExternalLink style={{ width: '0.75rem', height: '0.75rem' }} />
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div style={styles.profileCard}>
      <div style={styles.profileHeader}>
        <div style={styles.profileInfo}>
          <img
            src={getProfileImage()}
            alt={profile.username}
            style={styles.profileImage}
          />
          <div>
            <h3 style={styles.profileName}>{profile.full_name}</h3>
            <p style={styles.profileUsername}>@{profile.username}</p>
          </div>
        </div>
        <button
          onClick={onClose}
          style={styles.closeButton}
        >
          <X style={{ width: '1.25rem', height: '1.25rem' }} />
        </button>
      </div>

      <a
        href={getProfileLink()}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.profileLink}
      >
        View Profile <ExternalLink style={{ width: '1rem', height: '1rem' }} />
      </a>
      
      <div style={styles.profileContent}>
        {profile.biography && (
          <div style={styles.bioSection}>
            <span style={styles.bioLabel}>Biography</span>
            <p style={styles.bioText}>{profile.biography}</p>
          </div>
        )}
        
        {renderPlatformSpecificInfo()}
        {renderHashtagPosts()}
      </div>
    </div>
  );
};

const styles = {
  profileCard: {
    position: 'absolute',
    top: '8rem',
    right: '1rem',
    width: '24rem',
    backgroundColor: '#ffffff',  // Set to white to match the background
    borderRadius: '0.5rem',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '1.5rem',  // More padding for better spacing
    maxHeight: '80vh',
    overflowY: 'auto',
    fontFamily: 'Arial, sans-serif',
    color: '#333',  // Dark text for readability
  },
  profileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
  },
  profileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  profileImage: {
    width: '4rem',
    height: '4rem',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  profileName: {
    fontWeight: '700',
    fontSize: '1.25rem',
    color: '#333',
  },
  profileUsername: {
    color: '#888',
    fontSize: '0.875rem',
  },
  closeButton: {
    padding: '0.25rem',
    borderRadius: '50%',
    transition: 'background-color 0.2s',
  },
  profileLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    color: '#4CAF50',  // Green color for link
    marginBottom: '1rem',
  },
  profileLinkHover: {
    textDecoration: 'underline',
  },
  profileContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  bioSection: {
    padding: '0.5rem 0',
    borderBottom: '1px solid #e5e7eb',
  },
  bioLabel: {
    fontWeight: '600',
    marginBottom: '0.25rem',
    color: '#666',
  },
  bioText: {
    fontSize: '1rem',
    color: '#555',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.5rem 0',
    borderBottom: '1px solid #e5e7eb',
  },
  infoLabel: {
    fontWeight: '600',
    color: '#666',
  },
  infoValue: {
    fontWeight: '500',
    color: '#444',
  },
  hashtagPosts: {
    marginTop: '1rem',
  },
  hashtagPostsTitle: {
    fontWeight: '700',
    marginBottom: '0.5rem',
    color: '#333',
  },
  postList: {
    marginBottom: '0.5rem',
  },
  postItem: {
    padding: '1rem',
    backgroundColor: '#f9fafb',
    borderRadius: '0.5rem',
    marginBottom: '0.75rem',
  },
  postText: {
    fontSize: '1rem',
    marginBottom: '0.5rem',
  },
  postLink: {
    color: '#4CAF50',
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
};

export default ProfileCard;
